/**
 * ViewportController управляет размерами области просмотра и обновляет
 * соответствующие CSS-переменные.
 */

import { debounce } from 'application/utils/helpers'

export default class ViewportController {
  private header: HTMLElement
  private footer: HTMLElement

  constructor() {
    this.header = document.querySelector('header') as HTMLElement
    this.footer = document.querySelector('footer') as HTMLElement

    this.updateViewportSize()
    this.updateHeaderFooterHeights()

    window.addEventListener(
      'load',
      () => {
        this.updateViewportSize()
        this.updateHeaderFooterHeights()
      },
      { once: true }
    )

    window.addEventListener(
      'resize',
      debounce(() => {
        this.updateViewportSize()
        this.updateHeaderFooterHeights()
      }, 300)
    )
  }

  /**
   * Обновляет размеры области просмотра и соответствующие CSS-переменные.
   */
  private updateViewportSize(): void {
    const vh = window.innerHeight * 0.01
    const vw = document.body.clientWidth * 0.01
    const barWidth = window.innerWidth - document.documentElement.clientWidth
    document.documentElement.style.setProperty('--doc-height', `${vh}px`)
    document.documentElement.style.setProperty('--doc-width', `${vw}px`)
    document.documentElement.style.setProperty(
      '--scrollbar-width',
      `${barWidth}px`
    )
  }

  /**
   * Обновляет высоты header и footer в CSS-переменных.
   */
  private updateHeaderFooterHeights(): void {
    if (this.header && this.footer) {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      )
      document.documentElement.style.setProperty(
        '--footer-height',
        `${this.footer.offsetHeight}px`
      )
    }
  }

  /**
   * Обновляет размеры области просмотра и высоты header и footer.
   */
  public update(): void {
    this.updateViewportSize()
    this.updateHeaderFooterHeights()
  }
}

export function initViewportController(): ViewportController {
  return new ViewportController()
}
